/** What "Add" attaches: selected photos still loaded in the grid whose file is not attached yet. */
export const photosToAdd = <P extends { id: string; fileId: string }>(loaded: P[], selectedIds: Set<string>, excludeFileIds: string[] = []): P[] =>
  loaded.filter((p) => selectedIds.has(p.id) && excludeFileIds.indexOf(p.fileId) < 0)
